import React, { useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import { adaptHeightOnWidget } from '../../lib/ep.js';

import PrizesPageFlex from './PrizesPageFlex';

const PrizesPage = (props) => {
	const [ prizes, setPrizes ] = useState(props?.prizes ?? []);
	const [ prizes_filtered, setPrizesFiltered ] = useState(prizes);
	const [ search, setSearch ]  = useState("");
	useEffect(() => {
		let optimized_height_for_widget = 700;
		if(window.parent_location_w != undefined && window.parent_location_h != undefined) {
			optimized_height_for_widget = Math.min(window.parent_location_w, window.parent_location_h) + 70;
		}
		adaptHeightOnWidget(optimized_height_for_widget);
	}, []);

	const updatePrize = (prize_to_update) => {

		setPrizes((prizes) =>
			prizes.map((item) =>
			  item.id === prize_to_update.id ? { ...item, ...prize_to_update } : item
			)
		);

		setPrizesFiltered((prizes_filtered) =>
			prizes_filtered.map((item) =>
			  item.id === prize_to_update.id ? { ...item, ...prize_to_update } : item
			)
		);
	} 

	const normalizeText = (str, replace_spaces = true) => {
		const normalized = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
		if(!replace_spaces) return normalized;
		return normalized.replace(" ","_");
	};

	const findUsersInPrize = (name, splitted_value) => {
		const normalized_name = normalizeText(name);
		let found = true;

		for(let i = 0; i < splitted_value.length; i++) {
			const r = new RegExp(splitted_value[i], 'ig');
			if(found) found = r.test(normalized_name);
		}

		return found;
	};

	const searchPrize = (k, v) => {
		const found = [];

		const normalized_search = normalizeText(v, false);
		const splitted_value = normalized_search.trim().split(/ +/g);

		for(let p in prizes) {
			const prize = { ...prizes[p] };

			prize.Prize = (prize?.Prize ?? []).filter((winner) => {
				return findUsersInPrize(winner.name, splitted_value);
			});

			prize.Alternate = (prize?.Alternate ?? []).filter((alternate) => {
				return findUsersInPrize(alternate.name, splitted_value);
			});

			found.push(prize);
		}

		setSearch(v);
		//setPrizes(found);
		setPrizesFiltered(found);
	};

	const clickPrize = (p) => {
		if(props.clickPrize) props.clickPrize(p);
	};

	return (
		<PrizesPageFlex
			prizes={prizes_filtered}
			search={search}
			clickPrize={clickPrize}
			searchAction={searchPrize}
			prizeSection={props.prizeSection}
			is_builder={props.is_builder}
			updatePrize={updatePrize}
		/>
	);
};

export default injectIntl(PrizesPage);